import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LanguageService } from '@core/i18n/language.service';
import { LoadingService } from '@services/loading/loading.service';

@Component({
    selector: 'app-loading',
    imports: [],
    templateUrl: './loading.component.html',
    styleUrl: './loading.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingComponent {
  protected readonly loadingService = inject(LoadingService);
  private readonly langService = inject(LanguageService);

  protected readonly squares = Array.from({ length: 7 }, (_, i) => i);

  protected translateData: Record<string, string> = {};

  constructor() {
    this.langService
      .getSharedDictionary('loading').subscribe((data) => {
        this.translateData = data;
      });
  }

  protected titleChars(): string[] {
    return (this.translateData?.['title'] ?? '').split('');
  }
}
